import {NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

const coreRoutes: Routes = [];
@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(coreRoutes)
  ],
  declarations: [],
  exports: [RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class CoreRoutingModule { }
